import {
  FinancialWorkspaceValueObjectsAgreementDataTypeEnum,
  FinancialWorkspaceValueObjectsFinanceTypeEnum,
  FinancialWorkspaceValueObjectsInsightTableGroupEnum,
} from 'generated/resources/datatable.graphql'

import {
  InsightTableGroupBy,
  TableDataVariables,
} from 'modules/finance/components/FinancialWorkspace/types/table'
import { FinancialWorkspaceResource } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/types/data'

interface Props {
  customCategoryIds: string[]
  formattedState: TableDataVariables
  resource?: FinancialWorkspaceResource
  agreementDataTypes: FinancialWorkspaceValueObjectsAgreementDataTypeEnum[]
}

export interface FilterVariables {
  managerIds: string[]
  employeeIds: string[]
  locationIds: string[]
  costCenterIds: string[]
  legalEntityIds: string[]
  referenceContractTreeLevelUuids: string[]
  customCategoryIds: string[]
  agreementDataTypes?: FinancialWorkspaceValueObjectsAgreementDataTypeEnum[]
}

export interface Variables extends FilterVariables {
  search?: string
  formattedEndDate: string
  formattedStartDate: string
  groupBy: FinancialWorkspaceValueObjectsInsightTableGroupEnum
  financeTypes: FinancialWorkspaceValueObjectsFinanceTypeEnum[]
}

export const getFilteredVariables: ({
  resource,
  formattedState,
  customCategoryIds,
  agreementDataTypes,
}: Props) => {
  managerIds: string[]
  employeeIds: string[]
  locationIds: string[]
  costCenterIds: string[]
  legalEntityIds: string[]
  referenceContractTreeLevelUuids: string[]
  customCategoryIds: string[]
  agreementDataTypes?: FinancialWorkspaceValueObjectsAgreementDataTypeEnum[]
} = ({
  resource,
  formattedState,
  customCategoryIds,
  agreementDataTypes,
}: Props): FilterVariables => {
  const base = {
    customCategoryIds: customCategoryIds ?? [],
    employeeIds: formattedState.employeeIds ?? [],
    locationIds: formattedState.locationIds ?? [],
    costCenterIds: formattedState.costCenterIds ?? [],
    legalEntityIds: formattedState.legalEntityIds ?? [],
    referenceContractTreeLevelUuids: formattedState.referenceContractTreeLevelUuids ?? [],
    agreementDataTypes: agreementDataTypes.length ? agreementDataTypes : undefined,
  }

  if (!resource) {
    return {
      ...base,
      managerIds: [],
    }
  }

  const newObject = {
    ...base,
    managerIds: [],
  }

  switch (resource.type) {
    case InsightTableGroupBy.Employee:
      return { ...newObject, employeeIds: [resource.id] }
    case InsightTableGroupBy.Location:
      return { ...newObject, locationIds: [resource.id] }
    case InsightTableGroupBy.LegalEntity:
      return { ...newObject, legalEntityIds: [resource.id] }
    case InsightTableGroupBy.CostCenter:
      return { ...newObject, costCenterIds: [resource.id] }
    case InsightTableGroupBy.Manager:
      return { ...newObject, managerIds: [resource.id] }
    case InsightTableGroupBy.CustomCategory:
      return { ...newObject, customCategoryIds: [resource.id] }
    default:
      return newObject
  }
}
